import React, { useState } from "react";
import "./Toaster.scss";


export default function AcceptDeny(props) {
  const { modal, toggle, type, label = "SMS", message } = props;

  const defaultMessage = `Are you sure that you want to ${type ? (label === "SMS" ? "Deactive" : "Disable") : (label === "SMS" ? "Active" : "Enable")} ${label} Service?`;
  const displayMessage = message != null ? message : defaultMessage;

  return (
    <>
      <div className="toaster-modal">
        <div className={modal ? "modal-design-toster toster-show" : " modal-design-toster toster-hidden"}>
          <div className="toster-title">
            <p>{displayMessage}</p>
          </div>
          <div className="toster-footer">
            <button onClick={() => toggle()}>Cancel</button>
            <button style={{ backgroundColor: "#1479FF" }} onClick={() => toggle(true)}>
              <span style={{ paddingLeft: "8px", color: "#fff" }}>Yes</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
